"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = UITag;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _LightColors = _interopRequireDefault(require("../core/LightColors"));

var _MediumColors = _interopRequireDefault(require("../core/MediumColors"));

var _NormalColors = _interopRequireDefault(require("../core/NormalColors"));

var _underscore = require("../utils/underscore");

var _passthroughProps = _interopRequireDefault(require("../utils/propTypes/passthroughProps"));

var _Styles = require("../utils/Styles");

var _UICloseButton = _interopRequireDefault(require("../button/UICloseButton"));

var _UIClickable = _interopRequireDefault(require("../button/UIClickable"));

var _UILink = _interopRequireDefault(require("../link/UILink"));

var _UITruncateString = _interopRequireDefault(require("../text/UITruncateString"));

var _colors = require("HubStyleTokens/colors");

var _misc = require("HubStyleTokens/misc");

var _sizes = require("HubStyleTokens/sizes");

var _theme = require("HubStyleTokens/theme");

var USE_CLASSES = {
  // These do not come from the sketch file
  default: 'tag-default private-tag--default',
  primary: 'tag-primary',
  info: 'tag-info private-tag--info',
  success: 'tag-success private-tag--success',
  warning: 'tag-warning private-tag--warning',
  danger: 'tag-danger private-tag--danger',
  calypso: '',
  sorbet: '',
  lorax: '',
  marigold: '',
  'candy-apple': '',
  norman: '',
  thunderdome: '',
  oz: '',
  olaf: ''
};
var STATUS_ALIAS_MAP = {
  disabled: 'default',
  paused: 'default',
  draft: 'default',
  active: 'success',
  sent: 'success',
  published: 'success',
  inReview: 'warning',
  scheduled: 'warning',
  removed: 'danger',
  cancelled: 'danger',
  error: 'danger'
};
var USE_COLOR_ALIAS_MAP = {
  // defaults
  disabled: 'default',
  paused: 'default',
  draft: 'default',
  primary: 'default',
  // oz
  success: 'oz',
  active: 'oz',
  sent: 'oz',
  published: 'oz',
  // marigold
  warning: 'marigold',
  inReview: 'marigold',
  scheduled: 'marigold',
  // cand-apple
  danger: 'candy-apple',
  removed: 'candy-apple',
  cancelled: 'candy-apple',
  error: 'candy-apple',
  // calypso
  info: 'calypso'
};
var TAG_BACKGROUND_COLORS = Object.assign({}, _LightColors.default, {
  default: _colors.GYPSUM
});
var TAG_IS_BORDERED_BORDER_COLORS = Object.assign({}, _MediumColors.default, {
  default: _colors.EERIE
});
var TAG_BORDER_COLORS = Object.assign({}, _NormalColors.default, {
  default: _colors.EERIE
});

var getBackgroundColor = function getBackgroundColor(use) {
  return TAG_BACKGROUND_COLORS[use] != null ? TAG_BACKGROUND_COLORS[use] : _colors.EERIE;
};

var getBorderColor = function getBorderColor(use, bordered) {
  if (bordered && TAG_IS_BORDERED_BORDER_COLORS[use] != null) {
    return TAG_IS_BORDERED_BORDER_COLORS[use];
  } else if (TAG_BORDER_COLORS[use] != null) {
    return TAG_BORDER_COLORS[use];
  }

  return 'transparent';
};

var getInlineStyles = function getInlineStyles(inline) {
  return inline ? "\n        margin: 0 4px;\n        vertical-align: middle;\n      " : null;
};

var getCloseablePadding = function getCloseablePadding(closeable) {
  return closeable ? "\n        padding-right: 28px !important;\n      " : null;
};

var Tag = _styledComponents.default.span.withConfig({
  displayName: "UITag__Tag",
  componentId: "ndki7t-0"
})(["font-size:", ";background-color:", ";border:1px solid ", ";color:", ";line-height:", ";padding:", " ", ";", " position:relative;cursor:inherit;display:inline-flex;font-weight:", ";max-width:100%;overflow:hidden;user-select:none;vertical-align:8px;> * + *{margin-left:", ";}& + .private-tag{margin-left:", ";}a,a:hover,a:active{color:inherit;}", ""], _sizes.TAG_FONT_SIZE, function (props) {
  return getBackgroundColor(props.computedUse);
}, function (props) {
  return getBorderColor(props.computedUse, props._bordered);
}, function (props) {
  return props.computedUse === 'olaf' ? _colors.OLAF : _theme.BASE_FONT_COLOR;
}, (0, _Styles.toPx)(parseInt(_sizes.TAG_HEIGHT, 10) - 2), _sizes.TAG_PADDING_Y, _sizes.TAG_PADDING_X, function (props) {
  return getCloseablePadding(props.closeable);
}, _misc.WEB_FONT_DEMI_BOLD_WEIGHT, _sizes.TAG_ICON_SPACING_X, function (_ref) {
  var inline = _ref.inline;
  return inline ? null : _sizes.BASE_SPACING_X;
}, function (props) {
  return getInlineStyles(props.inline);
});

var FlexWrapper = _styledComponents.default.span.withConfig({
  displayName: "UITag__FlexWrapper",
  componentId: "ndki7t-1"
})(["display:inline-flex;max-width:100%;vertical-align:top;"]);

var ContentWrapper = _styledComponents.default.span.withConfig({
  displayName: "UITag__ContentWrapper",
  componentId: "ndki7t-2"
})(["overflow:hidden;"]);

var StyledCloseButton = (0, _styledComponents.default)(_UICloseButton.default).withConfig({
  displayName: "UITag__StyledCloseButton",
  componentId: "ndki7t-3"
})(["bottom:0;color:currentColor;margin-bottom:auto;margin-top:auto;position:absolute;right:6px;top:0;transform:scale(0.5);"]);
var StyledLink = (0, _styledComponents.default)(_UILink.default).withConfig({
  displayName: "UITag__StyledLink",
  componentId: "ndki7t-4"
})(["overflow:hidden;"]);
StyledLink.displayName = 'StyledUILink';
var LinkStyledClickable = (0, _styledComponents.default)(_UIClickable.default).withConfig({
  displayName: "UITag__LinkStyledClickable",
  componentId: "ndki7t-5"
})(["&&{font-weight:", ";overflow:hidden;text-decoration:underline;}"], _misc.WEB_FONT_MEDIUM_WEIGHT);
LinkStyledClickable.displayName = 'StyledUIClickable';

var renderContents = function renderContents(href, target, onClick, truncatedChildren) {
  var buttonClassName = 'private-tag__link';

  if (href) {
    return _react.default.createElement(StyledLink, {
      className: buttonClassName,
      href: href,
      onClick: onClick,
      target: target,
      use: "on-bright"
    }, truncatedChildren);
  } else if (onClick) {
    return _react.default.createElement(LinkStyledClickable, {
      className: buttonClassName,
      onClick: onClick
    }, truncatedChildren);
  }

  return _react.default.createElement(ContentWrapper, {
    className: "private-tag__content-wrapper"
  }, truncatedChildren);
};

function UITag(props) {
  var _avatar = props._avatar,
      _bordered = props._bordered,
      children = props.children,
      className = props.className,
      closeable = props.closeable,
      href = props.href,
      id = props.id,
      inline = props.inline,
      multiline = props.multiline,
      onClick = props.onClick,
      onCloseClick = props.onCloseClick,
      _onCloseMouseDown = props._onCloseMouseDown,
      target = props.target,
      truncateStringProps = props.truncateStringProps,
      use = props.use,
      rest = (0, _objectWithoutProperties2.default)(props, ["_avatar", "_bordered", "children", "className", "closeable", "href", "id", "inline", "multiline", "onClick", "onCloseClick", "_onCloseMouseDown", "target", "truncateStringProps", "use"]);
  var idRef = (0, _react.useRef)((0, _underscore.uniqueId)('tag-'));
  var computedId = id || idRef.current;
  var truncatedChildren = multiline ? children : _react.default.createElement(_UITruncateString.default, Object.assign({
    useFlex: true
  }, truncateStringProps), children);
  return _react.default.createElement(Tag, Object.assign({
    className: (0, _classnames.default)('tag', 'private-tag', className, USE_CLASSES[STATUS_ALIAS_MAP[use] || use], {
      'private-tag--bordered': _bordered,
      'private-tag--has-close': closeable,
      'private-tag--inline': inline
    }),
    "data-component-name": "UITag",
    id: computedId,
    computedUse: USE_COLOR_ALIAS_MAP[use] || use,
    _bordered: _bordered,
    closeable: closeable,
    inline: inline
  }, rest), _react.default.createElement(FlexWrapper, {
    className: "private-tag__flex-wrapper"
  }, _avatar, renderContents(href, target, onClick, truncatedChildren)), closeable && _react.default.createElement(StyledCloseButton, {
    "aria-describedby": computedId,
    className: "private-tag__close",
    onClick: onCloseClick,
    onMouseDown: _onCloseMouseDown
  }));
}

UITag.propTypes = {
  children: _propTypes.default.any,
  closeable: _propTypes.default.bool.isRequired,
  href: _propTypes.default.string,
  target: _propTypes.default.string,
  inline: _propTypes.default.bool.isRequired,
  multiline: _propTypes.default.bool.isRequired,
  onCloseClick: _propTypes.default.func,
  truncateStringProps: (0, _passthroughProps.default)(_UITruncateString.default),
  use: _propTypes.default.oneOf(Object.keys(USE_CLASSES).concat(Object.keys(STATUS_ALIAS_MAP))).isRequired,
  _avatar: _propTypes.default.node,
  // for UIAvatarTag
  _bordered: _propTypes.default.bool,
  // for MultiSelect
  _onCloseMouseDown: _propTypes.default.func // for MultiSelectValue

};
UITag.defaultProps = {
  _bordered: false,
  closeable: false,
  inline: false,
  multiline: false,
  use: 'default'
};
UITag.displayName = 'UITag';
UITag.STATUS_ALIAS_MAP = STATUS_ALIAS_MAP;
module.exports = exports.default;